import ValueProps from './ValueProps';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import omitProps from '../../hocs/omitProps';

const enhance = compose(
  withProps(props => {
    return {
      valueProps: props.items.map(item => {
        const { image } = item;
        return {
          useTrustpilot: item.useTrustpilot,
          text: item.text,
          height: image.dimensions.height,
          width: image.dimensions.width,
          src: image.url,
          numberOfFrames: image.dimensions.height / image.dimensions.width - 1,
        };
      }),
    };
  }),
  omitProps(['items'])
);

export default enhance(ValueProps);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ValueProps/index.js